import { Component, inject } from '@angular/core';
import { GridWidget } from '@eforall/dashboard';
import { DashboardListPartService } from './dashboard-list.part.service';


@Component({
	selector: 'dashboard-list-part',
	imports: [GridWidget],
	templateUrl: './dashboard-list.part.html',
	styleUrl: './dashboard-list.part.scss',
})
export class DashboardListPart {

	public readonly partService = inject(DashboardListPartService);

}
